import styled, { css } from "styled-components";

export const VoucherSwiperArrowContainerBox = styled.div<{isPrev?: boolean;}>`
    position: absolute;
    width: 3rem;
    height: 4rem;
    background-size: contain;
    /* background-color: red; */
    z-index: 2;
    /* display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    text-align: center; */
    font-size: 2rem;
    padding: 4px;
    cursor: pointer;
    top: 50%;
    transform: translate(0, -50%);
    ${({isPrev}) => isPrev ? css`
        left: 0;
        background-image: url(${({theme}) => theme.images.freePlay.swiperArrowPrev.toString()});
    ` : css`
        right: 0;
        background-image: url(${({theme}) => theme.images.freePlay.swiperArrowNext.toString()});
    `}
    &.swiper-button-disabled {
        opacity: 0.6;
    }
`
